import ToolTip from "components/General/ToolTip"
import { Stopwatch } from "react-bootstrap-icons"
import { AssignmentType } from "shared/types/assignmentTypes"
import { DateString } from "shared/types/commonTypes"
import { TeacherAssignmentResponse } from "shared/types/teacherTypes"
import Pane from "./General/Pane"
import { Col, Row } from "react-bootstrap"
import  assignmentStyles from "../Dashboards/Student/Student.module.scss"
import { useNavigate } from "react-router"
import * as assignmentRoute from "shared/routes/assignments"
import { formatToLongDate } from "helpers/dateHelper"
import { ReactNode } from "react"
import Paginator from "./General/Pagination/Paginator"

interface Props {
    ungradedSubmissions: UngradedSubmission[]
}

export type UngradedSubmission = {
    assignment: TeacherAssignmentResponse
    studentName: string
    submissionId: string
    submittedDate: DateString | Date
    assignmentType: AssignmentType
}

const PendingSubmissions = ({ ungradedSubmissions } : Props) => {
    const navigate = useNavigate()

    const navigateToSubmission = async (submission: UngradedSubmission) => {
        const submissionsResponse = (await assignmentRoute.getGrades({ assignmentId: submission.assignment.id })).data.filter(sub => sub.status === "submitted")
        const currentIndex = submissionsResponse.findIndex(res => res.submission.id === submission.submissionId)

        navigate("/dashboard/teacher/assignments/grading/submission", {
            state: {
                submissions: submissionsResponse,
                assignment: submission.assignment,
                currentIndex: currentIndex
            }
        })
    }

    const renderSubmission = (submission: UngradedSubmission, index: number) : ReactNode => {
        const isTopic = submission.assignmentType === "topic"
        const isLesson = submission.assignmentType === "lesson"

        return (
            <ToolTip title="Needs Grading" key={`${submission.submissionId}-${index}`}>
                <div onClick={() => navigateToSubmission(submission)}>
                    <Pane className={`shadow-sm mt-2 ${assignmentStyles.assignmentOverview}`}>
                        <Row>
                            <Col className="text-start" sm={12} md={7}>
                                <p className="fw-bold">{submission.assignment.title}</p>
                                <p className="text-muted fw-bold">{submission.studentName}</p>
                            </Col>
                            <Col className={`text-start`} sm={12} md={5}>
                                <p><span className="fw-bold">submitted:</span> {formatToLongDate(submission.submittedDate as DateString)}</p>
                                <p className={`rounded px-2 py-1 text-start d-inline ${isTopic ? assignmentStyles.labelTagTopic : isLesson ? assignmentStyles.labelTagLesson : assignmentStyles.labelTagAssessment}`}>{isTopic ? "topic" : isLesson ? "lesson" : "assessment"} submission</p>
                            </Col>
                        </Row>
                    </Pane>
                </div>
            </ToolTip>
        )
    }

    if (ungradedSubmissions.length === 0) return null

  return (
    <div className="p-2 mb-3">
        <h3 className="text-start ms-3 fw-bold mb-3">
            <Stopwatch className="me-2 text-primary" />
            Submissions to grade
        </h3>
        <Paginator items={ungradedSubmissions} renderItem={renderSubmission} position="down" />
    </div>
  )
}

export default PendingSubmissions
